(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-sliding-banner"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", function () {
    const sliding_banner_swiper = new Swiper('#sliding-banner .swiper', {
      loop: false,
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: '#sliding-banner .swiper-button-next',
        prevEl: '#sliding-banner .swiper-button-prev',
      },
      pagination: {
        el: '#sliding-banner .swiper-pagination',
        type: 'bullets',
        clickable: true,
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-announcements"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", function () {
    const site_announcements_swiper = new Swiper('#announcement-slider .swiper', {
      loop: true,
      autoplay: {
        delay: 5000,
      },
      disableOnInteraction: false,
      slidesPerView: 1,
    });
  });

  } catch(e) { console.error(e); }
})();
})();
